module.exports = __webpack_public_path__ + "static/media/LogicWheel6_1_drag_1.966cc3b7.png";